import { ensureDefined, SMap } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { HpError } from '@avantia/logging-and-errors';
import { DefaultHeadingControl } from './defaultHeadingControl';
import { HpHeadingControlFunction } from './headingTypes';

const defaultControl: HpHeadingControlFunction = DefaultHeadingControl;
const headingControls: SMap<HpHeadingControlFunction> = {
  Default: DefaultHeadingControl,
  DefaultInner: () => null
};

export function registerHeadingControl(controlFuncs: SMap<HpHeadingControlFunction>): void {
  const controlTypes = lodash.keys(controlFuncs);
  controlTypes.forEach((controlType) => {
    const key = controlType;
    const expectedSuffix = 'HeadingControl';
    if (!controlType.endsWith(expectedSuffix)) {
      throw new HpError(
        `A heading registered via registerHeadingControl(...) must end with the suffix '${expectedSuffix}'. Found '${controlType}' instead.`
      );
    } else {
      controlType = controlType.substring(0, controlType.length - expectedSuffix.length);
    }

    headingControls[controlType] = ensureDefined(controlFuncs[key], `headingControls['${controlType}']`);
  });
}

export function getHeadingControl(controlType: string | undefined): HpHeadingControlFunction {
  const control: HpHeadingControlFunction = controlType
    ? ensureDefined(headingControls[controlType], `headingControls['${controlType}']`)
    : defaultControl;
  return control;
}
